module.exports = __webpack_public_path__ + "img/insta.4ddcfea4.svg";